import { useMemo } from 'react';
import { z } from 'zod';
import { hydrogenDirectionValues } from 'src/apis/hydrogen-fcfs/mappings';
import type { HydrogenFcfsRoot } from 'src/apis/hydrogen-fcfs/types';
import {
  formOptionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import {
  preprocessAsArray,
  preprocessAsBoolean,
} from 'src/components/form/zod-utilities';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';

const createShema = (root: HydrogenFcfsRoot) =>
  z
    .object({
      nameOrIdentifier: z.string().nullable().default(null),
      directions: z.preprocess(
        preprocessAsArray,
        z.array(z.enum(hydrogenDirectionValues)).default([])
      ),
      ownedByMyOrg: z.preprocess(
        preprocessAsBoolean,
        z.boolean().default(root.isH2Operator ?? false)
      ),
      ownerOrganisation: formOptionSchema.nullable().default(null),
    })
    .merge(getPaginationSchema());

export const useHydrogenNetworkPointsOverviewPageParams = (
  root: HydrogenFcfsRoot
) => {
  const schema = useMemo(() => createShema(root), [root]);
  return usePageParamsFromSchema(schema, {
    filters: {
      nameOrIdentifier: { label: 'Name or Identifier' },
      directions: { label: 'Direction' },
      ownerOrganisation: { label: 'Owner Organisation' },
    },
  });
};

export type HydrogenNetworkPointsOverviewPageParams = ReturnType<
  typeof useHydrogenNetworkPointsOverviewPageParams
>;
